'use client'

import { useState } from 'react'
import parse from 'html-react-parser'
import { CONSTANTS_DATA } from '@constants/businessPages'
import Image from 'next/image'
import styles from './solutions.module.scss'

const Solutions = ({ solutionsData }) => {
  const [activeTab, setactiveTab] = useState(0)

  const allTabs = solutionsData?.tabsSection
  const isClickable = allTabs?.length !== 1
  const activeAccordionData =
    allTabs?.[activeTab]?.Content?.data?.attributes?.tabContent?.[0]?.Content?.data?.[0]?.attributes
      ?.accordionCards?.[0]
  const activeImagesData = [
    allTabs?.[activeTab]?.Content?.data?.attributes?.tabContent?.[0]?.Content?.data?.[0]?.attributes
      ?.accordionCards?.[1]?.accordionImage?.data,
    allTabs?.[activeTab]?.Content?.data?.attributes?.tabContent?.[0]?.Content?.data?.[0]?.attributes
      ?.accordionCards?.[2]?.accordionImage?.data,
  ]

  const reDirectWithUrl = url => {
    url && window.open(url)
  }

  const renderTabs = () => (
    <div className={styles.tabs}>
      {allTabs.map((tabData, index) => (
        <div
          className={`${styles.tab} ${index === activeTab ? styles.isActive : ''}`}
          onClick={() => setactiveTab(index)}>
          <div className={styles.each}>{tabData?.Content?.data?.attributes?.tabName}</div>
        </div>
      ))}
    </div>
  )

  const renderTabComp = () => (
    <>
      <div className={styles.accordion}>
        <div className={styles.accord}>
          <div className={styles.content}>
            <div className={styles.accordHeading} onClick={() => setactiveTab(activeTab)}>
              <div className={styles.boldText}>{activeAccordionData?.accordionHeading}</div>
            </div>
            <div className={`${styles.accordContent} ${styles.isActiveAccord}`}>
              <div className={styles.text}>{parse(activeAccordionData?.accordionContent)}</div>
              {activeAccordionData?.url && (
                <div className={styles.detailsButtonDesktop} onClick={() => reDirectWithUrl(activeAccordionData?.url)}>
                  {CONSTANTS_DATA?.seeDetails}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.image}>
        {activeImagesData?.[0] && (
          <div className={styles.desktopImage}>
            <Image
              src={activeImagesData?.[0]?.attributes?.url}
              alt="tabs image"
              width={activeImagesData?.[0]?.attributes?.width}
              height={activeImagesData?.[0]?.attributes?.height}
              loading="lazy"
            />
          </div>
        )}
        {activeImagesData?.[1] && (
          <div className={styles.mobileImage}>
            <Image
              src={activeImagesData?.[1]?.attributes?.url}
              alt="tabs image"
              width={activeImagesData?.[1]?.attributes?.width}
              height={activeImagesData?.[1]?.attributes?.height}
              loading="lazy"
            />
          </div>
        )}
      </div>
      {activeAccordionData?.url && (
        <div className={styles.detailsButtonMobile} onClick={() => reDirectWithUrl(activeAccordionData?.url)}>
          {CONSTANTS_DATA?.seeDetails}
        </div>
      )}
    </>
  )
  return (
    <div className={styles.mainClass}>
      <div className={styles.head}>{isClickable && renderTabs()}</div>
      <div className={styles.body}>{renderTabComp()}</div>
    </div>
  )
}

export default Solutions
